import React, { useEffect, useState } from 'react';
import MuiTable from '../../components/MuiTable/MuiTable';
import Button from '../../components/Button/Button';
import { useDispatch } from 'react-redux';
import {
  updateFlashBar,
  updateIsLoading,
  update_breadcrumb,
} from '../../redux/action';
import SearchInput from '../../components/SearchInput/SearchInput';
import PageHeading from '../../components/PageHeading/PageHeading';
import { useNavigate } from 'react-router-dom';
import InputForm from '../../components/InputForm/InputForm';
import axiosInstance from '../../service/axiosInstane';
import { errorMessage } from '../../config/errorsMsg';
import { flashBarTheme } from '../../config/flashBar';
import Input from '../../components/Input/Input';
import { SortOrderType } from '../../config/enum';
import qs from 'qs';
import { totalPages } from '../../config/helpers';
import { successMessage } from '../../config/keyword';
const columns = [
  {
    id: 'text',
    label: 'Noise Word',
    minWidth: 100,
    align: 'left',
  },
  {
    id: 'noiseAction',
    label: 'Action',
    minWidth: 0,
    align: 'right',
  },
];
type ResponseProps = {
  id: string;
  text: string;
  organizationId: string;
  isMasterData: boolean;
};

type RequestProps = {
  page: number;
  pageSize: number;
  searchText: string;
  sortBy: string;
  sortOrder: string;
};
type NoisewordResult = {
  text: string;
  organizationId: string;
  id: string;
  isMasterData: boolean;
};
type NoiseWordResponseProps = {
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  results: NoisewordResult[];
};

const NoiseWords = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const breadcrumb = [{ path: '/noiseWords', name: 'Noise Word' }];
  const [formError, setFormError] = useState<any>({});
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [state, setState] = useState<{ text: string }>({
    text: '',
  });
  const [userState, setUseState] = useState<NoisewordResult[]>([]);
  const { text } = state;
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [requestState, setRequestState] = useState<RequestProps>({
    page: page,
    pageSize: limit,
    searchText: '',
    sortBy: '',
    sortOrder: SortOrderType.ASC,
  });

  useEffect(() => {
    dispatch(update_breadcrumb(breadcrumb));
    getNoiseWords(requestState);
  }, []);

  useEffect(() => {
    if (Object.keys(formError).length === 0 && isSubmit) {
      addNoiseWord();
    }
  }, [formError]);

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const format = /^\S*$/;
    format.test(event.target.value) &&
      setState({
        ...state,
        [event.target.name]: event.target.value,
      });

    if (event.target.value !== '' || Number(event.target.value) !== 0) {
      setFormError({ ...formError, [event.target.name]: undefined });
    } else {
      setFormError({
        ...formError,
        [event.target.name]: `Noise Word Required`,
      });
    }
  };

  const gotResponse = (data: NoiseWordResponseProps) => {
    if (data.results === null) {
      setUseState([]);
    } else {
      setUseState(data.results as NoisewordResult[]);
      setTotalRowCount(data.totalCount);
    }
    dispatch(updateIsLoading(false));
  };

  const validation = () => {
    const error: any = {};
    if (!text) {
      error.text = errorMessage.emptyNoiseWord;
    } else if (text.length > 32) {
      error.text = errorMessage.noiseWordLength;
    }

    return error;
  };

  const onCancel = () => {
    setIsFormOpen(false);
    setIsSubmit(false);
    setFormError({});
    setState({
      ...state,
      text: '',
    });
  };

  const viewRecord = (row: ResponseProps) => {
    navigate(`/noiseWordDetails/${row.id}`);
  };

  const onSubmit = () => {
    setFormError(validation());
    setIsSubmit(true);
  };

  const addNoiseWord = () => {
    const obj = {
      text: text,
    };
    dispatch(updateIsLoading(true));
    axiosInstance
      .post('/noise-words', obj)
      .then((response) => {
        if (response.status === 201) {
          const obj = {
            isOpen: true,
            message: successMessage.NOISEWORD_ADD,
            type: flashBarTheme.SUCCESS,
          };
          navigate(`/noiseWordDetails/${response.data.id}`);
          dispatch(updateFlashBar(obj));
          setIsFormOpen(false);
          getNoiseWords({
            ...requestState,
            page: page,
            pageSize: limit,
            sortBy: '',
          });
          setState({
            ...state,
            text: '',
          });
          dispatch(updateIsLoading(false));
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message || err.response.data.errors.Code[0],
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const getNoiseWords = (obj: RequestProps) => {
    dispatch(updateIsLoading(true));
    const queryString = qs.stringify(obj, { arrayFormat: 'repeat' });
    const url = `/noise-words?${queryString}`;
    axiosInstance
      .get(url)
      .then((response) => {
        if (response.status === 200) {
          gotResponse(response.data);
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const searchHandler = () => {
    getNoiseWords({
      ...requestState,
      searchText: requestState.searchText,
      pageSize: limit,
    });
  };
  const onSearchHanlder = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRequestState({ ...requestState, searchText: e.target.value, page: 1 });
    setPage(1);
  };
  const handleEnterKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      searchHandler();
    }
  };
  const onClearSearch = () => {
    setRequestState({
      ...requestState,
      searchText: '',
      page: page,
      pageSize: limit,
    });
    getNoiseWords({
      ...requestState,
      searchText: '',
      page: page,
      pageSize: limit,
    });
  };

  const sorting = (sortOrder: string) => {
    let temp = '';
    if (sortOrder == SortOrderType.DESC) {
      temp = SortOrderType.ASC;
    } else {
      temp = SortOrderType.DESC;
    }
    setRequestState({ ...requestState, sortOrder: temp });
    return temp;
  };
  const sortRecord = (fieldName: string, sortOrder: string) => {
    getNoiseWords({
      ...requestState,
      sortOrder: sorting(sortOrder),
      sortBy: fieldName,
      page: page,
      pageSize: limit,
    });
    setRequestState({
      ...requestState,
      sortBy: fieldName,
      sortOrder: sorting(sortOrder),
    });
  };

  const paginateHandler = {
    onClickPageNumber: (page: number) => {
      getNoiseWords({ ...requestState, page: page, pageSize: limit });
      setPage(page);
    },
    onNextClick: () => {
      if (page < totalPages(totalRowCount, limit)) {
        getNoiseWords({
          ...requestState,
          page: page + 1,
          pageSize: limit,
        });
        setPage(page + 1);
      }
    },
    onPrevClick: () => {
      if (page > 1) {
        getNoiseWords({
          ...requestState,
          page: page - 1,
          pageSize: limit,
        });
        setPage(page - 1);
      }
    },
    onFirstClick: () => {
      if (page !== 1) {
        getNoiseWords({
          ...requestState,
          page: 1,
          pageSize: limit,
        });
        setPage(1);
      }
    },
    onLastClick: () => {
      if (page !== totalPages(totalRowCount, limit)) {
        getNoiseWords({
          ...requestState,
          page: totalPages(totalRowCount, limit),
          pageSize: limit,
        });
        setPage(totalPages(totalRowCount, limit));
      }
    },

    limitHandler: (item: number) => {
      getNoiseWords({
        ...requestState,
        page: 1,
        pageSize: item,
      });
      setLimit(item);
      setPage(1);
    },
  };

  return (
    <>
      <div className="px-2">
        <PageHeading label="Noise Word Management" />
        <div className="bg-white p-2 rounded-sm shadow-md">
          <div className="lg:flex items-center justify-between lg:space-y-1">
            <SearchInput
              value={requestState.searchText}
              onChange={onSearchHanlder}
              onSearch={searchHandler}
              onClear={() => onClearSearch()}
              handleEnterKeyPress={handleEnterKeyPress}
            />
            <div className="mt-1">
              <Button
                label="Add"
                type="button"
                buttonType="primary"
                icon={<i className="fa-solid fa-plus"></i>}
                onClick={() => setIsFormOpen(!isFormOpen)}
              />
            </div>
          </div>

          <InputForm
            title={'Add New Noise Word'}
            isFormOpen={isFormOpen}
            onSubmit={onSubmit}
            onCancel={onCancel}
          >
            <div className="lg:flex items-center justify-between">
              <Input
                name={'text'}
                type={'text'}
                label={'Noise Word'}
                value={text}
                placeholder={`Enter Noise Word`}
                onChange={handleChange}
                error={formError?.text}
              />
            </div>
          </InputForm>
          <div className="mt-1">
            <MuiTable
              columns={columns}
              rows={userState}
              page={page}
              limit={limit}
              paginateHandler={paginateHandler}
              totalRowCount={totalRowCount}
              onSortHandler={sortRecord}
              sortOrder={requestState.sortOrder}
              checkBoxShow={false}
              checkBoxValue={'id'}
              onViewHandler={viewRecord}
              showView={true}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default NoiseWords;
